// extracted by mini-css-extract-plugin
export default {"addToCartControl":"Z1-z","giftCard":"_1-z","btnContainer":"a2-z","cartButton":"b2-z","disabled":"c2-z"};